export const customFormatDate = (dateStr, locale) => {
  if (!dateStr) return ""

  const [day, month, year] = dateStr.split(".")
  const date = new Date(year, month - 1, day)

  let result = new Intl.DateTimeFormat(locale, {
    day: "2-digit",
    month: "short",
  }).format(date)

  result = result.replace(
    /(\d{2})\s(.+)/,
    (_, d, m) => `${d} ${m.charAt(0).toUpperCase()}${m.slice(1)}`
  )

  return result
}

export const formatDateArray = (arr, locale) => {
  if (!arr || arr.length === 0) return ""

  const validDates = arr.filter((date) => date !== null)

  if (validDates.length === 0) return ""
  if (validDates.length === 1) return customFormatDate(validDates[0], locale) ?? ""

  const firstDate = validDates[0]
  const lastDate = validDates[validDates.length - 1]

  return `${customFormatDate(firstDate, locale) ?? ""} - ${customFormatDate(lastDate, locale) ?? ""}`
}

export const ddmmyyyyformatDate = (day, date) => {
  return `${String(day).padStart(2, "0")}.${String(date.getMonth() + 1).padStart(2, "0")}.${date.getFullYear()}`
}

export const strToddmmyyyyDate = (str) => {
  if (!str) return new Date()
  const [day, month, year] = str.split(".").map(Number)
  return new Date(year, month - 1, day)
}

export const formatToApiDate = (ddmmyyyy) => {
  if (!ddmmyyyy) return undefined
  const [dd, mm, yyyy] = ddmmyyyy.split(".")
  return `${yyyy}-${mm}-${dd}`
}
